import { useEffect, useState } from "react";
import { api } from "../api";
import { CheckCircle2, MapPin } from "lucide-react";
import SEO from "../components/SEO";

export default function RegistroPromesse() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/platform/registro-promesse").then(r => setD(r.data)); }, []);
  if (!d) return <main className="py-32 container-x"><div className="font-mono text-xs" style={{ opacity: 0.6 }}>Loading...</div></main>;
  return (
    <main data-testid="registro-page">
      <SEO
        title="Registro pubblico delle promesse"
        description="Dashboard aperta: per ogni azienda del portafoglio, dipendenti al riferimento vs oggi, sede confermata, marchio confermato, investimenti realizzati. La trasparenza come vantaggio competitivo del capitale paziente."
        path="/registro-promesse"
      />
      <section style={{ background: "var(--bone)" }} className="py-20 md:py-28">
        <div className="container-x">
          <div className="overline" style={{ color: "var(--terracotta)" }}>Registro pubblico delle promesse</div>
          <h1 className="serif-display mt-6" style={{ fontSize: "clamp(40px, 5.5vw, 76px)", lineHeight: 1.05, maxWidth: 1100 }}>
            Le promesse che facciamo,<br />
            <span style={{ color: "var(--terracotta)", fontStyle: "italic" }}>verificate anno per anno.</span>
          </h1>
          <p className="mt-8 text-lg md:text-xl" style={{ maxWidth: 780, opacity: 0.78, lineHeight: 1.7 }}>
            Per ogni azienda tipo del portafoglio: dipendenti al momento di riferimento vs oggi, sede confermata, marchio confermato, investimenti realizzati. Nessun fondo può permettersi questa trasparenza. Per noi è il ponte tra parole e fatti.
          </p>
        </div>
      </section>

      <section className="py-16" style={{ background: "var(--muted)" }}>
        <div className="container-x">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <Big value={d.aggregate.companies} label="Aziende tracciate" />
            <Big value={"+" + d.aggregate.total_new_hires} label="Assunzioni nette" />
            <Big value={"€" + d.aggregate.total_capex_eur_m + "M"} label="Investimenti realizzati" />
            <Big value={d.aggregate.brand_preserved_pct + "%"} label="Marchio e sede preservati" />
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="container-x">
          <div className="overline mb-6" style={{ color: "var(--terracotta)" }}>Il registro</div>
          <div className="overflow-x-auto">
            <table className="w-full" style={{ borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: "2px solid var(--midnight)" }}>
                  <th className="text-left font-mono text-xs py-3">AZIENDA</th>
                  <th className="text-left font-mono text-xs py-3">SETTORE</th>
                  <th className="text-left font-mono text-xs py-3">REGIONE</th>
                  <th className="text-right font-mono text-xs py-3">DAL</th>
                  <th className="text-right font-mono text-xs py-3">HC RIFERIMENTO</th>
                  <th className="text-right font-mono text-xs py-3">HC OGGI</th>
                  <th className="text-right font-mono text-xs py-3">Δ</th>
                  <th className="text-right font-mono text-xs py-3">CAPEX (€M)</th>
                  <th className="text-center font-mono text-xs py-3">SEDE</th>
                  <th className="text-center font-mono text-xs py-3">MARCHIO</th>
                </tr>
              </thead>
              <tbody>
                {d.entries.map(e => (
                  <tr key={e.company_id} style={{ borderBottom: "1px solid var(--border)" }} data-testid={`registro-row-${e.company_id}`}>
                    <td className="py-4 serif-display" style={{ fontSize: 20 }}>{e.name}</td>
                    <td className="py-4"><span className="chip">{e.sector}</span></td>
                    <td className="py-4 font-mono text-sm" style={{ opacity: 0.7 }}><MapPin size={13} style={{ display: "inline", marginRight: 4, opacity: 0.6 }} />{e.region}</td>
                    <td className="text-right font-mono">{e.since}</td>
                    <td className="text-right font-mono">{e.employees_at_reference}</td>
                    <td className="text-right font-mono"><b>{e.employees_today}</b></td>
                    <td className="text-right font-mono" style={{ color: "#065F46" }}>+{e.employees_delta}</td>
                    <td className="text-right font-mono">€{e.capex_investment_eur_m}M</td>
                    <td className="text-center">{e.hq_preserved && <CheckCircle2 size={18} style={{ color: "#065F46", display: "inline" }} />}</td>
                    <td className="text-center">{e.brand_preserved && <CheckCircle2 size={18} style={{ color: "#065F46", display: "inline" }} />}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="mt-6 text-xs font-mono" style={{ opacity: 0.55 }}>Aggiornato: {new Date(d.generated_at).toLocaleDateString('it-IT', { day: '2-digit', month: 'long', year: 'numeric' })}. Numeri illustrativi delle tipologie di aziende di riferimento.</p>
        </div>
      </section>
    </main>
  );
}
function Big({ value, label }) {
  return (
    <div data-testid={`big-${label}`}>
      <div className="serif-display" style={{ fontSize: 56, lineHeight: 1, color: "var(--midnight)" }}>{value}</div>
      <div className="mt-3 text-sm" style={{ opacity: 0.75 }}>{label}</div>
    </div>
  );
}
